/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Coinbase
 */
export class Coinbase {
    /**
     *
     * @type {string}
     * @memberof Coinbase
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Coinbase
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Coinbase
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Coinbase
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Coinbase
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Coinbase
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Coinbase
     */
    autoApprove: boolean;
}
